import { Storage } from "../util/Storage";
import PerformanceMonitor from "./monitoring/PerformanceMonitor";
import makeMeasure from "./makeMeasure";
import fireEREvt from "./eventRecorderClient";

const timeout = <T>(timeoutInMs: number): Promise<T> => new Promise((_, reject) => {
    setTimeout(() => reject(`RequestTimeout after ${ timeoutInMs }ms`), timeoutInMs);
});

const get = <T>(url: string): Promise<T> => {
    const options: HeadersInit = { method: "GET" };

    return fetch(url, options).then((response) => {
        if (response.ok) {
            return response.json();
        }

        return Promise.reject(response);
    });
};

export const makeCachedGet = <T>(name: string, getFn = get) => {
    let pendingPromise: Promise<T> | undefined = undefined;
    const performanceMonitor = new PerformanceMonitor(`Sparkle:${ name }`);
    const withTiming = makeMeasure(performanceMonitor);
    const local = Storage.createLocalStorage();

    return (url: string, timeoutInMs: number, defaultRes: T, localStorageKey?:string): Promise<T> => {

        if (!pendingPromise) {
            pendingPromise = withTiming(name, () => getFn<T>(url).then((res) => {
                if (localStorageKey) local.setObj(localStorageKey, res as Record<string, string>);
                fireEREvt(`${ name }-api-res`, res);

                return res;
            }));
        }

        if (localStorageKey) {
            const cachedTargetingData = local.getObj(localStorageKey);

            if (cachedTargetingData) {
                return Promise.resolve(cachedTargetingData as T);
            }
        }

        return Promise.race([pendingPromise as Promise<T>, timeout<T>(timeoutInMs)])
            .catch((err) => {
                if (defaultRes) return defaultRes;
                throw err;
            });
    };
};
